import { regex } from '../parsers/regex';

/**
 * A regex parser that matches any characters. Max length is 2000 characters.
 *
 * Use this parser to parse notes, or comments.
 */
export const notes = regex(/.{0,2000}/);
